import { useAuth } from "@/context/AuthContext";
import { APP_NAME } from "@/lib/brand";
import { AuthBackdrop } from "./AuthBackdrop";

export const PendingScreen = () => {
  const { user, logout } = useAuth();
  return (
    <AuthBackdrop testid="pending-screen">
      <div className="auth-brand serif" data-testid="pending-brand">{APP_NAME}</div>
      <h1 className="serif text-2xl text-neutral-900 mt-6">{user.blocked ? "This account has been blocked" : "Your account is waiting for approval"}</h1>
      <p className="text-neutral-600 mt-3 text-sm" data-testid="pending-message">
        {user.blocked
          ? ""
          : `Thanks for signing up, ${user.name || user.email}. The family admin will approve your account soon. Check back a little later.`}
      </p>
      <button className="btn-outline mt-6 w-full" onClick={logout} data-testid="pending-logout-button">Sign out</button>
    </AuthBackdrop>
  );
};
